<template>
  <div class="bread">
    <span
      :key="item"
      v-for="(item, index) in list"
      :class="index === list.length - 1 ? 'normal active' : 'normal'"
      >{{ index === list.length - 1 ? item : `${item}/` }}</span
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: []
    };
  },
  created() {
    const { matched } = this.$route;
    this.list = matched.map(item => item.meta.name);
  }
};
</script>

<style scoped lang="scss">
.bread {
  height: 56px;
  padding-left: 30px;
  line-height: 56px;
}

.normal {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #bbbbbb;
  margin-right: 3px;
}

.active {
  color: $theme-color;
}
</style>
